import { AnimationMixer, LoopOnce, LoopRepeat } from "three";
import { AnimationClip } from "three";
import { Group } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

export class Asset extends Group {
    constructor(uri, callback) {
        super();
        //console.log(uri);
        if (uri)
            this.name = uri.replace(/^.*[\\\/]/, '');
        if (!Asset.loader) {
            Asset.loader = new GLTFLoader();
        }
        if (uri) {
            Asset.loader.load(
                // resource URL
                uri,
                // called when the resource is loaded
                function (gltf) {
                    const modelLoaded = gltf.scene;
                    this.add(modelLoaded)
                    if (callback) {
                        callback(modelLoaded, this);
                    }
                }.bind(this),
                // called while loading is progressing
                null,
                // called when loading has errors
                function (error) {

                    console.log('An error happened', error);

                }
            );
        }
    }

    isAsset() {
        return true
    }
}

export class AnimatedAsset extends Group {
    constructor(uri, callback) {
        super();
        if (uri)
            this.name = uri.replace(/^.*[\\\/]/, '');
        if (!Asset.loader) {
            Asset.loader = new GLTFLoader();
        }
        if (uri) {
            Asset.loader.load(
                // resource URL
                uri,
                // called when the resource is loaded
                function (gltf) {

                    // Create an AnimationMixer, and get the list of AnimationClip instances
                    this.mixer = new AnimationMixer(gltf.scene);
                    this.clips = gltf.animations;
                    const modelLoaded = gltf.scene;
                    this.add(modelLoaded)


                    if (callback) {
                        callback(modelLoaded, this);
                    }
                }.bind(this),
                // called while loading is progressing
                null,
                // called when loading has errors
                function (error) {

                    console.log('An error happened', error);

                }
            );
        }
    }

    activateAllAnimation(currentAction = 'Idle') {
        for (let clip of this.clips) {
            let action = this.mixer.clipAction(clip);
            action.play();
            if (clip.name == currentAction) {
                action.setEffectiveWeight(1);
            } else {
                console.log(clip.name)
                action.setEffectiveWeight(0)
            }
        }
    }

    fadeTo(nextAction) {
        if (!this.clips)
            return;

        for (let clip of this.clips) {
            let action = this.mixer.clipAction(clip);

            if (clip.name == nextAction) {
                if (action.weight < 1) {
                    const effectiveWeight = action.weight + 0.1;
                    action.setEffectiveWeight(effectiveWeight)
                }
            } else {
                if (action.weight > 0) {
                    const effectiveWeight = action.weight - 0.1;
                    action.setEffectiveWeight(effectiveWeight)
                }


            }
            //console.log();
        }
    }


    play(animationName, repetition = 0) {
        // Play a specific animation
        const clip = AnimationClip.findByName(this.clips, animationName);
        const action = this.mixer.clipAction(clip);
        // let loopMode = repetition == 0 ? LoopOnce : LoopRepeat;
        // if (repetition < 0) {
        //     action.setLoop(loopMode)
        // } else {
        //     action.clampWhenFinished = true;
        //     action.setLoop(loopMode, repetition)
        // }
        action.reset();
        action.setLoop(LoopOnce)
        action.clampWhenFinished = true;

        action.play();
    }


    isAsset() {
        return true
    }

    isAnimated() {
        return true
    }

    update(delta) {
        if (this.mixer)
            this.mixer.update(delta);


        this.updateMatrixWorld();
        this.traverse((o) => {
            if (o.type.indexOf("Mesh") > 0) {
                //o.geometry.computeFaceNormals();
                //o.updateMatrix()
                //o.geometry.computeVertexNormals();
                //o.geometry.computeTangents();
            }
        })
        //console.log(this)
    }
}